import { render, staticRenderFns } from "./preloaderSpin.vue?vue&type=template&id=22af47c2&scoped=true&"
import script from "./preloaderSpin.vue?vue&type=script&lang=js&"
export * from "./preloaderSpin.vue?vue&type=script&lang=js&"
import style0 from "./preloaderSpin.vue?vue&type=style&index=0&id=22af47c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22af47c2",
  null
  
)

export default component.exports